import { useState } from "react";
import { ReactRelayContext } from "react-relay";
import { useSelector } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import classNames from "classnames";

import appRelayEnvironment from "../config/AppRelayEnvironment";
import { usePageScrolledObserver } from "./Utils/usePageScrolledObserver";
import { Provider as AppContainerProvider } from "./Main/AppContainerContext";
import SkipToContentButton from "./Header/SkipToContentButton";
import Alert from "./Alerts/Alert";
import FixedActionButtonsManager from "./FixedActions/FixedActionButtonsManager";

const App = props => {
  const { children } = props;

  const [appContainer, setAppContainer] = useState();
  const fullScreenMode = useSelector(({ styling }) => styling.fullScreenMode);
  const iFrameMode = useSelector(({ styling }) => styling.iFrameMode);
  const paddingTop = useSelector(({ styling }) => styling.affixHeaderOffsetTop);
  const isPageScrolled = useSelector(({ styling }) => styling.isPageScrolled);

  usePageScrolledObserver();

  const className = classNames("app", {
    "full-screen": fullScreenMode,
    iframe: iFrameMode,
    scrolled: isPageScrolled
  });

  return (
    <>
      <SkipToContentButton />

      <div className={className} id="app" ref={setAppContainer} style={{ paddingTop }}>
        <ReactRelayContext.Provider
          value={{ environment: appRelayEnvironment, variables: {} }}
        >
          <HelmetProvider>
            {appContainer && (
              <AppContainerProvider value={appContainer}>
                <Alert />

                <FixedActionButtonsManager>{children}</FixedActionButtonsManager>
              </AppContainerProvider>
            )}
          </HelmetProvider>
        </ReactRelayContext.Provider>
      </div>
    </>
  );
};

export default App;
